import Vue from 'vue'
import {mapGetters, mapActions} from 'vuex'

import menuI from 'js/pages/municipality/index.js'
import icoSend from 'assets/learn-more/ico-send.svg'
import imageLeftTop from 'assets/learn-more/image-left-top.png'
import imageLeftBottom from 'assets/learn-more/image-left-bottom.png'
import imageRight from 'assets/learn-more/image-right.png'
import BonoOro from 'assets/learn-more/Tarjeta_bono_oro.png'
import WawaJoven from 'assets/learn-more/Tarjeta_Wawa_Joven.jpg'
import BonoResidenteCanario from 'assets/learn-more/Tarjeta-Residente.png'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import template from './index.pug'

// Este index.js es exactamente igual que en el core. La idea sería eliminar este archivo y tirar únicamente del core
// El problema es que en el index.pug (vl) no funciona el menu con el elemento ul del index.pug (core) ( no se por qué) así que hasta que no encuentre
// el fallo no podremos usar únicamente core, que es la idea.

// @vue/component
export default Vue.extend({
  name: 'learn-more',
  template: template(),
  components: {
    menuI,
    VuePdfEmbed
  },
  data() {
    return {
      selected: undefined,

      pestanaActiva: 'Inicio',
      imageSend: icoSend,
      image_left_top: imageLeftTop,
      image_left_bottom: imageLeftBottom,
      image_right: imageRight,
      Bono_Oro: BonoOro,
      Wawa_Joven: WawaJoven,
      Bono_Residente_Canario: BonoResidenteCanario,
      tableData: [
        {
          name: 'TGC mejora para ti',
          page: null,
          pdfSource: this.$t('learn_more.url_file_information')
        }
      ]
    }
  },

  created() {

  },

  methods: {
    redirect(data) {
      const elementoTexto = document.getElementById(data)
      elementoTexto.focus()
    },
    download() {
      const link = document.createElement('a')
      link.href = PDFTarjeta
      link.download = 'Beneficiate_de_la_nueva_tarjeta_digital.pdf' // Nombre con el que se descargará el archivo
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
})
